import React, { Component } from "react";

export class HeroSection extends Component {
  render() {
    let { heightSubtract, vheight, overlay } = this.props;

    vheight = vheight || 100;
    const height = heightSubtract
      ? "calc(" + vheight + "vh - " + heightSubtract + ")"
      : vheight + "vh";
    let className = overlay ? "HeroSection hero_overlay" : "HeroSection";
    className = className + " " + this.props.className;

    return (
      <div>
        <br></br>
        <div className="topSection">
          <img src="/images/dropshadowheader.png" alt="header" />
        </div>

        <section
          id={this.props.id}
          className={className}
          style={{
            minHeight: height,
            backgroundColor: this.props.backgroundColor || "",
          }}
        >
          <div
            className="innerContainer"
            style={this.props.innerContainerStyle}
          >
            <div className="mainContent">{this.props.children}</div>
          </div>
        </section>
        <div className="bottomSection">
          <img src="/images/dadifotur.png" alt="footer" />
        </div>
      </div>
    );
  }
}

export default HeroSection;
